import { NgModule } from '@angular/core';
import { BackDirective } from './directives/back.directive';
import { TranslateDataValuePipe } from './pipes/translate-data-value.pipe';
import { TranslateFieldNamePipe } from './pipes/translate-field-name.pipe';
import { TranslateArrayValuePipe } from './pipes/translate-array-value.pipe';
import { CancelEditableRowDirective, DeleteEditableRowDirective, EditableColumnDirective, EditableTableDirective, SaveEditableRowDirective } from './directives/editable-table.directive';
import { FocusTrapDirective } from './directives/focustrap.directive';
import { ConcatFieldValuePipe } from './pipes/concat-field-value.pipe';
import { DynamicDecimalPipe } from './pipes/dynamic-decimal.pipe';

@NgModule({
  declarations: [
    BackDirective,
    TranslateDataValuePipe,
    TranslateFieldNamePipe,
    TranslateArrayValuePipe,
    EditableTableDirective,
    EditableColumnDirective,
    SaveEditableRowDirective,
    CancelEditableRowDirective,
    DeleteEditableRowDirective,
    FocusTrapDirective,
    ConcatFieldValuePipe,
    DynamicDecimalPipe
  ],
  imports: [

  ],
  exports: [
    BackDirective,
    TranslateDataValuePipe,
    TranslateFieldNamePipe,
    TranslateArrayValuePipe,
    EditableTableDirective,
    EditableColumnDirective,
    SaveEditableRowDirective,
    CancelEditableRowDirective,
    DeleteEditableRowDirective,
    FocusTrapDirective,
    ConcatFieldValuePipe,
    DynamicDecimalPipe
  ]
})
export class IbpaasBaseComponentModule { }
